"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorTypes = void 0;
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["IS_REQUIRED"] = "IS_REQUIRED";
    ErrorTypes["INVALID_EXPIRATION_DATE"] = "INVALID_EXPIRATION_DATE";
    ErrorTypes["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
    ErrorTypes["INVALID_CVV"] = "INVALID_CVV";
    ErrorTypes["INVALID_VALUE"] = "INVALID_VALUE";
    ErrorTypes["EMPTY"] = "";
    ErrorTypes["NEED_FILL_ALL_FIELDS"] = "You need to fill all the fields or enter valid values";
    ErrorTypes["VGS_UNAUTHORIZED"] = "Unauthorized, please check the \"userToken\" field and verify that it is a valid value";
})(ErrorTypes = exports.ErrorTypes || (exports.ErrorTypes = {}));
